import { combineReducers } from 'redux';
import {
  arrayToObject,
} from 'src/utils/helpers';
import { TaskTypes } from 'src/redux/docbase/action_types';
// verified_keys
function all(state = {}, action) {
  switch (action.type) {
    case TaskTypes.GET_TASKS_HISTORY_SUCCESS:
      return arrayToObject(action.data.results);
    case TaskTypes.GET_TASKS_SUCCESS:
    case TaskTypes.GET_TASKS_VERIFIED_SUCCESS:
      return arrayToObject(action.data);
    case TaskTypes.UPDATE_TASK_SUCCESS: {
      console.table('UPDATE_TASK_SUCCESS in reducer entities/task', state, action);
      const updatedState = { ...state };

      if (updatedState[action?.taskId]) {
        updatedState[action?.taskId] = {
          ...updatedState[action?.taskId],
          value: action?.value,
          is_verified: action.data?.is_verified,
          justUpdated: true
        };
      }

      if (action.data?.verified_keys && Array.isArray(action.data.verified_keys)) {
        action.data.verified_keys.forEach(taskId => {
          if (updatedState[taskId]) {
            updatedState[taskId] = {
              ...updatedState[taskId],
              is_verified: true
            };
          }
        });
      }

      return updatedState;
    }
    case TaskTypes.SKIP_TASK_SUCCESS: {
      const updatedState = { ...state };
      const taskId = action?.payload?.task_id || action?.data?.id || action?.data?.task_id;
      if (taskId && updatedState[taskId]) {
        updatedState[taskId] = {
          ...updatedState[taskId],
          status: 'skipped',
          justSkipped: true
        };
      } else {
        console.error('Task not found in all state. TaskId:', taskId);
      }
      return updatedState;
    }
    case TaskTypes.AFFIRM_TASK_SUCCESS: {
      const updatedState = { ...state };
      const taskId = action?.task_id;
      const accept = action?.params?.accept;
      if (taskId && updatedState[taskId]) {
        updatedState[taskId] = {
          ...updatedState[taskId],
          manually_accept: accept
        };
      }
      return updatedState;
    }
    default:
      return state;
  }
}

function ui(state = [], action) {
  switch (action.type) {
    case TaskTypes.GET_TASKS_HISTORY_SUCCESS:
      return action.data.results;
    case TaskTypes.GET_TASKS_SUCCESS:
      return action.data;
    case TaskTypes.UPDATE_TASK_SUCCESS: {
      const haveVerifiedKeys = action.data?.verified_keys && Array.isArray(action.data.verified_keys);
      return state?.map(item => {
        if (item?.id === action?.taskId) {
          return {
            ...item,
            value: action?.value,
            is_verified: action.data?.is_verified,
            justUpdated: true
          }
        }
        if (haveVerifiedKeys && action.data.verified_keys.includes(item?.id)) {
          return {
            ...item,
            is_verified: true,
          }
        }
        return item;
      })
    }
    case TaskTypes.SKIP_TASK_SUCCESS: {
      // Try multiple possible locations for task_id
      const taskId = action?.payload?.task_id || action?.data?.id || action?.data?.task_id;
      return state?.map(item => {
        if (item?.id === taskId) {
          return {
            ...item,
            status: 'skipped',
            justSkipped: true
          }
        }
        return item;
      })
    }
    case TaskTypes.AFFIRM_TASK_SUCCESS: {
      const taskId = action?.task_id;
      const accept = action?.params?.accept;
      return state?.map(item => {
        if (item?.id === taskId) {
          return {
            ...item,
            manually_accept: accept
          }
        }
        return item;
      })
    }
    default:
      return state;
  }
}

function allVerified(state = {}, action) {
  switch (action.type) {
    case TaskTypes.GET_TASKS_VERIFIED_SUCCESS:
      return arrayToObject(action.data);
    case TaskTypes.UPDATE_TASK_SUCCESS:
      if (action?.taskVerifiedId && !action?.isForReview) {
        return {
          ...state,
          [action?.taskVerifiedId]: {
            ...state[action?.taskVerifiedId],
            value_after_acceptance: action?.value
          }
        }
      }
      return state;
    default:
      return state;
  }
}

function uiVerified(state = [], action) {
  switch (action.type) {
    case TaskTypes.GET_TASKS_VERIFIED_SUCCESS:
      return action.data;
    case TaskTypes.UPDATE_TASK_SUCCESS:
      if (action?.taskVerifiedId && !action?.isForReview) {
        return state?.map(item => {
          if (item?.id === action?.taskVerifiedId) {
            return {
              ...item,
              value_after_acceptance: action?.value
            }
          }
          return item;
        })
      }
      return state;
    default:
      return state;
  }
}

function meta(state = {}, action) {
  switch (action.type) {
    case TaskTypes.GET_COUNT_TASK_SUCCESS:
      return {
        ...state,
        ...action.data
      };
    case TaskTypes.CHANGE_COUNT_TASK: {
      const { countData, target } = action.payload;
      const updatedState = { ...state };
      Object.keys(updatedState).forEach(key => {
        if (key === target) {
          updatedState[key] = countData;
        }
      });
      return updatedState;
    }
    default:
      return state;
  }
}

function tasksImage(state = {}, action) {
  switch (action.type) {
    case TaskTypes.GET_TASK_IMAGE_SUCCESS:
      if (action.get_full_size) {
        return {
          ...state,
          [action.taskId]: {
            ...state[action.taskId],
            image_full_size: action.data
          },
        };
      } else {
        return {
          ...state,
          [action.taskId]: {
            ...state[action.taskId],
            image: action.data
          },
        };
      }
    default:
      return state;
  }
}

function taskStatusCount(state = {}, action) {
  switch (action.type) {
    case TaskTypes.GET_TASKS_HISTORY_SUCCESS: {
      const {results, ...others} = action.data;
      return {...state, ...others};
    }
    default:
      return state;
  }
}

export default combineReducers({
  all,
  ui,
  tasksImage,
  allVerified,
  uiVerified,
  meta,
  taskStatusCount
  // metaVerified
})